import api from '../api';

const END_POINT = "/api/categories";
/**
 * This method will load all categories from the database with a get http call
 * @returns {} it is returning a promise with all categories
 */
export async function getAll() {
  return await api.get(`${END_POINT}`);
}
/**
 * This method is adding a category from the database with a post http call
 * 
 * @param  {Object - categoryDto} category object that we want to add from the database
 * @returns {} it is returning a promise with the added category
 */
export async function save(category) {
  return await api.post(
    `${END_POINT}`,
    {
      name: category.name,
      id: category.id,
      version: category.version,
    }
  );
}
/**
 * This method is updating a category from the database with a put http call
 * 
 * @param  {Object - categoryDto} category object that we want to update from the database
 * @returns {} it is returning a promise with the updated category
 */
export async function update(category) {
  return await api.put(
    `${END_POINT}`,
    {
      id: category.id,
      name: category.name,
      version: category.version,
    }
  );
}

/**
 * This method is removing a category from the database with a delete http call
 * 
 * @param  {long} id id of the category we want to remove from the database
 * @returns {} it is returning a promise. You will have 202 status if the category was deleted successfully.
 */
export async function deleteById(id) {
  return await api.delete(
    `${END_POINT}/${id}`
  );
}